import { render, staticRenderFns } from "./WidgetHorsePension.vue?vue&type=template&id=6d92ebcb&"
import script from "./WidgetHorsePension.vue?vue&type=script&lang=js&"
export * from "./WidgetHorsePension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports